import { useContext, useMemo } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { BodyContainer } from '../../../../elements/Common';
import { PickListTab } from './list';
import { RouteTabs } from '../../../../components';
import { CommonUtility, Tabs } from '../../../../utility';
import { CompletePickListTab } from './complete-list';
import { useGlobalContext } from '../../../../contexts';
import { useSecondaryHeader } from '../../../../hooks/useSecondaryHeader';
import { PackingTabExtraContext } from '../../../../contexts/packing-tab-extra';

function PackingSecondaryHeader({ menus, currentTab, tabClicked }) {
  const { tabExtra } = useContext(PackingTabExtraContext);

  return (
    <RouteTabs
      items={menus}
      activeKey={currentTab}
      onChange={tabClicked}
      tabBarExtraContent={tabExtra}
      className="no-header"
    />
  );
}

function PackingListScreenContent() {
  const { warehouseId } = useGlobalContext();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const currentTab = useMemo(() => {
    if (pathname) {
      return CommonUtility.getSegmentByPosition(pathname, 5);
    }
    return null;
  }, [pathname]);

  const tabClicked = tabName => {
    navigate(`/app/fulfill/packing/list/${tabName}`);
  };

  const menus = [
    {
      text: 'To Pack',
      value: Tabs.PackingTabs.toPack,
    },
    {
      text: 'Complete',
      value: Tabs.PackingTabs.complete,
    },
  ];

  useSecondaryHeader(
    () => (
      <PackingSecondaryHeader
        menus={menus}
        currentTab={currentTab}
        tabClicked={tabClicked}
      />
    ),
    [currentTab, tabClicked],
  );

  return (
    <BodyContainer className="tab-layout no-header">
      <Routes>
        <Route index element={<Navigate to={Tabs.PackingTabs.toPack} />} />
        <Route
          path={Tabs.PackingTabs.toPack}
          element={<PickListTab warehouseId={warehouseId} />}
        />
        <Route
          path={Tabs.PackingTabs.complete}
          element={<CompletePickListTab warehouseId={warehouseId} />}
        />
      </Routes>
    </BodyContainer>
  );
}

export function PackingListScreen() {
  return <PackingListScreenContent />;
}
